import React from 'react';
import { List } from '@mui/material';
import MainAgendaListItem from './MainAgendaListItem';

function MainAgendaList({ agendaItems, onClick, onEventClick, onPostpone, onComplete, dateTimeFormat }) {
  return (
    <List>
      {agendaItems.map((item) => (
        <MainAgendaListItem
          key={item.id}
          item={item}
          onClick={onClick}
          onEventClick={onEventClick}
          onPostpone={onPostpone}
          onComplete={onComplete}
          dateTimeFormat={dateTimeFormat}
        />
      ))}
    </List>
  );
}

export default MainAgendaList;
